import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLInputElement> {
  connect() {
    this.element.value = Intl.DateTimeFormat().resolvedOptions().timeZone
  }
}
